import React from 'react';
import { FormControlLabel as MuiFormControlLabel } from '@mui/material';

const FormControlLabel = (props) => {
  return (
    <MuiFormControlLabel {...props} />
  );
};

export default FormControlLabel;
